export const API_AUTH = {
  LOGIN: "/authToken1",
  REFRESH: "/refreshToken",
}

export const API_USER = {
  CHANGE_PASSWORD: "/user/changePassword",
  RESET_PASSWORD: "/user/resetPassword",
  SEARCHUSER: "/user/searchUser",
  GET_USERBYID: "/user/getUserById",
  ADD_USER: "/user/addUser",
  UPDATE_USER: "/user/updateUser",
  GET_ROLES: "/user/getRoles",
  ADD_ROLES: "/user/addRole",
  UPDATE_ROLES: "/user/updateRole",
  DELETE_ROLE: '/user/deleteRole',
  GET_PRIVILEGES: "/user/getPrivileges",
  ADD_PRIVILEGE: "/user/addPrivilege",
  UNLOCK_USER: "/user/unlockUser",
  UPDATE_STATUS: "/user/updateUserActiveInactive",
  UPDATE_ROLE: "/user/updateUserRole",
  USER_PROFILE_GET: "/user/getUserProfile",
  USER_PROFILE_UPDATE: "/user/addUpdateUserProfile",
  GET_DASHBOARD_DATA: "/user/getDashboardData",
  GET_USER_LIST: "/user/list",
  GET_USER_ACTIVITY_LOG: "/user-action/logs",
  EXPORT_USERS: "/export/users",
  EXPORT_TAXONOMY:"/export/taxonomy",
  EXPORT_USER_MANAGEMENT_LOGS: "/export/userManagementLogs"
 

}

export const API_URL = {
  GET_CATEGORY_SCORE_TYPE_BY_PROJECT_ID: "/prompt/getCategoryScoreTypeByProjectId",
  GET_CATEGORY_SCORE_TYPE_BY_PROJECT_ID_APPLICABLE: "/prompt/getApplicableCategoryScoreTypeByProjectId",
  GET_CATEGORY_SCORE_TYPE: "/prompt/getCategoryScoreType",
  ADD_CATEGORY_SCORE_TYPE: "/prompt/addCategoryScoreType",
  DELETE_CATEGORY_SCORE_TYPE: "/prompt/deleteCategoryScoreType",

  GET_PROMPT_TYPE: "/prompt/getPromptType",
  GET_PROMPT_TYPE_BY_PROJECT_ID: "/prompt/getPromptTypeByProjectId",
  GET_PROMPT_TYPE_BY_PROJECT_ID_APPLICABLE: "/prompt/getApplicablePromptTypeByProjectId",
  ADD_PROMPT_TYPE: "/prompt/addPromptType",
  DELETE_PROMPT_TYPE: "/prompt/deletePromptType",

  GET_PROMPT: "/prompt/list",
  POST_DRAFT_PROMPT: "/prompt/searchDraftPrompts",
  POST_ALL_PROMPTS: "/prompt/searchPrompts",
  POST_RECYCLE_BIN_PROMPT: "/prompt/searchDeletedPrompts",
  GET_DRAFT_PROMPT_BY_ID: "/prompt/getPromptById",
  POST_PUBLISHED_PROMPT: "/prompt/searchPublishedPrompts",
  ADD_PROMPT: "/prompt/save",
  PUBLISH_PROMPT: "/prompt/publish",
  DELETE_PROMPT: "/prompt/delete",
  PERMANENT_DELETE_PROMPT: "/prompt/permanentDelete",
  RESTORE_PROMPT: "/prompt/restore",
  IMPROVED_PROMPT_SCORE: "/prompt/improvedScore",
  REVISED_PROMPT: "/prompt/revisedPrompt",
  GUIDED_PROMPT: "/prompt/guidedPrompt",
  RUN_DOCUMENT: "/prompt/runDocument",
  VALIDATE_PROMPT: "/prompt/validatePrompt",
  CHAT_GENERATED_PROMPT: "/prompt/chatGeneratedPrompt",
  GET_CHAT_GENERATED_PROMPT: "/prompt/getChatGeneratedPrompt",
  GET_VERSION_LIST: '/prompt/versions',
  GET_PROMPT_BY_VERSION: '/prompt/getPromptByVersion',
  GET_PUBLISHED_PROMPT_BY_ID: "/prompt/getPublishedPromptById",
  POST_BULK_PUBLISH_PROMPT: "/prompt/bulkPromptPublish",
 


  POST_PROCESS_SUMMARY: "/prompt/processSummary",
  RUN_VALIDATION: "/validation/validationCases",
  GET_VALIDATION: "/validation/getValidation",
  ADD_VALIDATION: "/validation/saveValidation",
  DELETE_VALIDATION: "/validation/deleteValidation",
  VALIDATION_PROMPT_MAPPING: "/validation/validationPromptMapping",

  SET_PROJECT: "/setProject",
  GET_PROJECT: "/project/getProjects",
  GET_PROJECT_LIST: "/project/listProjects",
  ADD_PROJECT: "/project/add",
  DELETE_PROJECT: "/project/deleteProject",
  ADD_CATEGORY_SCORE_TYPE_PROJECT_CONFIGURATION:  "/project/addCategoryScoreTypeToProjectConfiguration",
  ADD_PROMPT_TYPE_PROJECT_CONFIGURATION: "/project/addPromptTypeToProjectConfiguration",

  GET_PROJECT_CONFIGURATION: "/project/getProjectConfiguration",
  GET_GUIDED_PROMPT_QUESTION: "/project/getGuidedPromptQuestion",
  ADD_GUIDED_PROMPT_QUESTION: "/project/addGuidedPromptQuestion",
  DELETE_GUIDED_PROMPT_QUESTION: "/project/deleteGuidedPromptQuestion",

  ADD_TAXONOMY: "/taxonomy/add",
  GET_TAXONOMY: "/taxonomy/getTaxonomy",
  DELETE_TAXONOMY: "/taxonomy/delete",

  GET_TAXONOMY_BY_PARENT_ID: "/taxonomy/getTaxonomyByParentId",
  GET_TAXONOMY_BY_PROJECT_ID: "/taxonomy/getTaxonomyByProject",
  GET_LEVEL_ONE_TAXONOMY: "/taxonomy/getLevelOneTaxonomy",
  GET_TAXONOMY_TREE_BY_PROJECT_ID: "/taxonomy/getTaxonomyTreeByProject",
  GET_TAXONOMY_TYPE_BY_PROJECT_ID: "/taxonomy/getTaxonomyTypeByProjectId",
  GET_TAXONOMY_TYPE: "/taxonomy/getTaxonomyType",
  ADD_TAXONOMY_TYPE: "/taxonomy/addTaxonomyType",
  DELETE_TAXONOMY_TYPE: "/taxonomy/taxonomyType/delete",
  GET_TAXONOMY_BY_PROJECT_AND_TAXONOMY_TYPE: "/taxonomy/getTaxonomyByProjectAndTaxonomyType",
  GET_TAXONOMY_SEARCH: "/search/getTaxonomy",
  POST_TAXONOMY_SEARCH: "/search/getTaxonomy",
  GENERATE_CODE: "/taxonomy/generateCode",

  EXPORT_PROMPT_LIBRARY: "/export/prompt",
  EXPORT_PROMPT_LIBRARY_JSON: "/export/exportPrompt",
  IMPORT_PROMPT_LIBRARY: "/import/prompts",
  EXPORT_VALIDATION:"/export/validation",
  EXPORT_VALIDATION_JSON:"/export/exportValidationRule",
  IMPORT_VALIDATION_JSON: "/import/validationRules",
  IMPORT_PROMPT_UPDATE_EXCEL: "/import/prompts/update",

  GET_AGENT_LIST: "/gpt-agent/list",
  ADD_GPT_AGENT: "/gpt-agent/add",
  DELETE_GPT_AGENT: "/gpt-agent/delete",

   MULTI_RUN_PROMPT: "/prompt/uploadExcel",
   GET_MULTI_RUN_PROMPT_STATUS: "/prompt/getPromptStatus",
   DOWNLOAD_MULTI_RUN_PROMPT_RESULT: "/prompt/downloadResult",
   DOWNLOAD_MULTI_RUN_PROMPT_SAMPLE_FORMAT: "/prompt/sample-format"
}
